import axios from '../api/private';

export const updateCustomer = (customerdata) => {
	return axios.post('/customer/update', customerdata);
};